// import { SetState, GetState } from '../store.types';
import { GetState, SetState } from '../store.types';
import {
  bulkSendOpsToRTDB,
  incrementNodeIndexInRTDB,
  subscribeToDiagramV2,
} from '../../service/diagram.rtdb';
import { Operation } from '../../model/operation.model';
import { DiagramState } from '../diagram.store';
export interface SessionSlice {
  sessionId: string;
  clientId: string;
  lockedElements: Set<string>;
  unsubscribeFn?: Promise<() => void>;
  sendOperations: () => Promise<void>;
  receiveOperation: (op: Operation) => void;
  subscribeToSession: () => void;
  receiveIndex: (index: number) => void;
  sendIndex: (index?: number) => Promise<void>;

  // lockElement: (elementId: string) => void;
  // unlockElement: (elementId: string) => void;
  // setSessionInfo: (sessionId: string, clientId: string) => void;
}

export const createSessionSlice = (
  set: SetState,
  get: GetState,
): SessionSlice => ({
  sessionId: '',
  clientId: '',
  unsubscribeFn: undefined,
  lockedElements: new Set(),
  sendOperations: async () => {
    const outbox = get().outbox;
    const diagramId = get().data?.id;

    if (!outbox.size || !diagramId) return;
    const operations = [...outbox.values()];

    set(() => ({
      outbox: new Map(),
    }));
    await bulkSendOpsToRTDB(diagramId, operations);
  },
  receiveOperation: (operation) => {
    set((s: DiagramState) => {
      if (s.ledger.has(operation.opId)) {
        return s;
      } else {
        s.applyOperationChanges(operation.changes);
        return {
          ledger: new Map(s.ledger).set(operation.opId, operation),
        };
      }
    });
  },
  subscribeToSession: async () => {
    const receiveOperation = get().receiveOperation;
    const receiveIndex = get().receiveIndex;
    const receiveUpdate = get().meta.receiveUpdate;
    const diagramId = get().data?.id;
    if (!diagramId) return;
    // const sessionExists = await checkForSessionInRTDB(id);
    // if (!id || !sessionExists) return;
    const unsubscribe = subscribeToDiagramV2(diagramId, {
      receiveOperation,
      receiveIndex,
      receiveUpdate,
    });
    set(() => ({
      unsubscribeFn: unsubscribe,
    }));
  },
  receiveIndex: (index) => {
    set((s: DiagramState) => ({
      ...s,
      nodeIndex: index,
    }));
  },
  sendIndex: async (index) => {
    const diagramId = get().data?.id;
    if (!diagramId) return;
    await incrementNodeIndexInRTDB(diagramId, index);
  },
});
